import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getDumpPanInfo(params, signal) {
  return request({
    url: '/dumpPanInfo',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getDumpPanTotal(params, signal) {
  return request({
    url: '/dumpPanInfo/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExportDumpPan(params) {
  return request({
    url: '/dumpPanInfo/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deletePanInfo(uuid) {
  return request({
    url: `/dumpPanInfo/${uuid}`,
    method: 'delete',
  });
}
